export class AzureDiskRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "azureDisk",
            "baseName": "azureDisk",
            "type": "AzureDiskTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureDiskRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
